import { render, staticRenderFns } from "./FabricForm.vue?vue&type=template&id=f074c76a&scoped=true&"
import script from "./FabricForm.vue?vue&type=script&lang=js&"
export * from "./FabricForm.vue?vue&type=script&lang=js&"
import style0 from "./FabricForm.vue?vue&type=style&index=0&id=f074c76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f074c76a",
  null
  
)

export default component.exports